import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { DocumentRef } from '@planone/shared/util-browser-api';
import { localizedMeta, MetaService } from '@planone/shared/util-meta';
import { RESPONSE } from '@planone/shared/util-ssr';
import { Response } from 'express';

@Component({
  selector: 'bau365-shell-page-service-unavailable',
  templateUrl: './page-service-unavailable.component.html',
  styleUrls: ['./page-service-unavailable.component.scss'],
})
export class PageServiceUnavailableComponent implements OnInit, OnDestroy {
  constructor(
    @Optional() @Inject(RESPONSE) private response: Response,
    private document: DocumentRef,
    private metaService: MetaService
  ) {
    this.metaService.setTitle(localizedMeta['titleServiceUnavailable']);
  }

  ngOnInit() {
    if (this.response) {
      this.response.status(503);
    }

    this.document.nativeDocument.getElementById('body')?.classList.add('error');
  }

  ngOnDestroy() {
    this.document.nativeDocument.getElementById('body')?.classList.remove('error');
  }
}
